// eslint-disable-next-line @typescript-eslint/no-unused-vars
/* eslint-disable @typescript-eslint/no-explicit-any */
import produce from 'immer';
import { GET_INFO_CUSTOMER_DONE } from './constant';

export type CustomerPaymentState = {
  infoCustomer: any;
};

const initState: CustomerPaymentState = {
  infoCustomer: {},
};

const cauHinhDiaChiReducer = (
  state = initState,
  action: ActionType,
): CustomerPaymentState => {
  return produce(
    state,
    (draftState: CustomerPaymentState): CustomerPaymentState => {
      switch (action.type) {
        case GET_INFO_CUSTOMER_DONE:
          draftState.infoCustomer = action.payload;
          return draftState;
        default:
          return draftState;
      }
    },
  );
};

export default cauHinhDiaChiReducer